import _ from 'lodash'
import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col } from "react-flexbox-grid"
import { gsap } from "gsap"
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import Markdown from '../Markdown'

import './Footer.scss';

const Footer = ({ title, intro, email, text }) => {
  const refFooter = useRef()
  const refEmail = useRef()
  const refText = useRef()

  useEffect(() => {
    if (refFooter) {
      gsap.registerPlugin(ScrollTrigger);

      if (refEmail) {
        gsap.from(refEmail.current, {
          opacity: 0,
          x: 40,
          scrollTrigger: {
            trigger: refFooter.current,
            start: "top 100%",
            end: "+=30%",
            scrub: true,
            once: true,
          }
        })
      }
      if (refText) {
        gsap.from(refText.current, {
          opacity: 0,
          x: 40,
          scrollTrigger: {
            trigger: refFooter.current,
            start: "top 100%",
            end: "+=30%",
            scrub: true,
            once: true,
          }
        })
      }
    }
  }, [])

  return (
    <footer ref={refFooter} className="footer">
      <div className="footer__inner">
        <Grid>
          {title ? 
            <Row>
              <Col sm={12} md={12}>
                <Markdown className="footer__title">{title}</Markdown> 
                {email ? <a ref={refEmail} className="footer__link" href={`mailto:${email}`}>{email}</a> : null}
              </Col>
            </Row>
          : null }
        </Grid>
      </div>
      <div className="footer__bottom">
        <Grid>
          <Row between="md">
            <Col sm={12} md={12} lg={9}>
              
                {intro ? <span className="footer__subtitle">{intro}</span> : null}
                {text ? 
                  <div ref={refText}>
                    <Markdown className="footer__text">{text}</Markdown> 
                  </div>
                : null}
            </Col>
          </Row>
        </Grid>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  title: PropTypes.string.isRequired,
  intro: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  text: PropTypes.string,
};

Footer.defaultProps = {
  title: '',
  intro: '',
  emails: ''
};

export default Footer
